module.exports = __webpack_public_path__ + "static/media/sale.b6f86dc3.svg";